(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["premium-discount-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePopup = (popup) => {
      if (!popup || popup.dataset.initialized === 'true') return;

      popup.dataset.initialized = 'true';

      const storageKey = `marka_popup_${popup.dataset.sectionId}`;
      const delay = Number(popup.dataset.delay) || 2000;
      const frequencyDays = Number(popup.dataset.frequency) || 7;
      const closeButtons = popup.querySelectorAll('[data-popup-close]');
      const dialog = popup.querySelector('.marka-popup__box');
      const isThemeEditor = window.Shopify && Shopify.designMode;

      let previouslyFocusedElement = null;

      const hasRecentlySeenPopup = () => {
        if (isThemeEditor) return false;

        try {
          const savedTime = Number(localStorage.getItem(storageKey));

          if (!savedTime) return false;

          const frequencyMilliseconds =
            frequencyDays * 24 * 60 * 60 * 1000;

          return Date.now() - savedTime < frequencyMilliseconds;
        } catch (error) {
          return false;
        }
      };

      const savePopupView = () => {
        if (isThemeEditor) return;

        try {
          localStorage.setItem(storageKey, Date.now().toString());
        } catch (error) {
          // Popup still works if localStorage is unavailable.
        }
      };

      const openPopup = () => {
        previouslyFocusedElement = document.activeElement;

        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('marka-popup-open');

        const closeButton = popup.querySelector('.marka-popup__close');

        if (closeButton) {
          setTimeout(() => closeButton.focus(), 100);
        }
      };

      const closePopup = () => {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('marka-popup-open');

        savePopupView();

        if (previouslyFocusedElement) {
          previouslyFocusedElement.focus();
        }
      };

      closeButtons.forEach((button) => {
        button.addEventListener('click', closePopup);
      });

      document.addEventListener('keydown', (event) => {
        if (!popup.classList.contains('is-visible')) return;

        if (event.key === 'Escape') {
          closePopup();
        }

        if (event.key === 'Tab' && dialog) {
          const focusableElements = dialog.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          );

          if (!focusableElements.length) return;

          const firstElement = focusableElements[0];
          const lastElement =
            focusableElements[focusableElements.length - 1];

          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (
            !event.shiftKey &&
            document.activeElement === lastElement
          ) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      });

      if (!hasRecentlySeenPopup()) {
        window.setTimeout(openPopup, isThemeEditor ? 300 : delay);
      }
    };

    document.querySelectorAll('[data-popup]').forEach(initializePopup);

    document.addEventListener('shopify:section:load', (event) => {
      const popup = event.target.querySelector('[data-popup]');
      initializePopup(popup);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const popup = event.target.querySelector('[data-popup]');

      if (popup) {
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('marka-popup-open');
      }
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      const popup = event.target.querySelector('[data-popup]');

      if (popup) {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('marka-popup-open');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
